export default __webpack_public_path__ + "static/media/video_img.c0c5b172.jpg";